

const tickets = {
  // Tickets
  tickets: {
    title: "Tickets",
    create: "Create Ticket",
    list: "My Tickets",
    createTicket: "Create Ticket",
    selectedMatches: "Selected Matches",
    totalOdds: "Total Odds",
    potentialWin: "Potential Win",
    stake: "Stake",
    refresh: "Refresh",
    submitted: "Submitted Tickets",
    noTickets: "No tickets yet",
    submittedDesc: "Your submitted tickets will appear here once you create them.",
    matchDetails: "Match Details",
    odds: "Odds",
    confidence: "Confidence",
    won: "Won",
    lost: "Lost",
    pending: "Pending",
    delete: "Delete",
    deleteSuccess: "Ticket deleted successfully",
    deleteError: "Failed to delete ticket",
    deleteConfirmTitle: "Delete Ticket",
    deleteConfirmDesc: "Are you sure you want to delete this ticket? This action cannot be undone.",
    evaluationTitle: "Ticket Evaluation",
    evaluationDesc: "AI-powered analysis of your ticket quality and potential.",
    evaluationSummary: "Evaluation Summary",
    impactPositive: "Positive Impact",
    impactNegative: "Negative Impact",
    impactNeutral: "Neutral Impact",
    noMatches: "No matches available",
    // Additional missing translations for ticket configuration
    configuration: "Ticket Configuration",
    general: "General",
    advanced: "Advanced",
    settings: "Settings",
    options: "Options",
    preferences: "Preferences",
    parameters: "Parameters",
    match: "Match",
    matches: "Matches",
    league: "League",
    selected: "Selected",
    reviewBeforeSubmit: "Review your selections before submitting",
    actions: "Actions",
    prediction: "Prediction",
    clearAll: "Clear All",
    copy: "Copy",
    submit: "Submit",
    submitting: "Submitting...",
    evaluate: "Evaluate"
  }
};

export default tickets;

